<template>
  <div class="mt-1">
    <census-toolbar />
    <div class="card mx-md-3 mt-1 mb-3">
      <card-header
        :title="$t('census.history')"
        :iconName="'card-checklist'"
      />
      <b-card-body>
        <b-alert variant="danger" v-model="popAlert" dismissible> {{ this.errorMessage }} </b-alert>
        <template v-on:error:api.capture="handleError" v-if="this.censusList != null">
          <census-table
            :list="this.censusList"
            :censusHistory="censusHistory"
            :usersAccessibleUnits="usersAccessibleUnits"
            @show-census="showCensus"
            @change-census-year="changeCensusYear"
            @change-display-unit="changeDisplayUnit"
            @search-by-dates="searchByDates"
          />
        </template>
        <template v-on:error:api.capture="handleError" v-if="this.selectedCensus != null">
          <census-form
            :selectedCensus="this.selectedCensus"
            :list="this.membersList"
          />
        </template>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import cardHeader from "../../components/common/cardHeader";
import censusToolbar from "../../components/census/censusToolbar";
import censusTable from "../../components/census/censusTable";
import censusForm from "../../components/census/censusForm";
import EsepService from "../../services/member.service";
import {handleApiError} from "@/services/error.service";
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";

export default {
  computed: {
    censusHistory() {
      let history;
      if (this.$route.name == "censusHistory") {
        history = true;
      } else if (this.$route.name == "censusSubmit") {
        history = false;
      }
      return history;
    },
  },
  created() {
    EsepService.getCurrentCensusPeriod().then(
      (response) => {
        this.currentCensusYear = response.data.yearCensus;
        this.censusYear = this.currentCensusYear;
        this.censusYears = [this.currentCensusYear, this.currentCensusYear - 1];
      },
      (error) => {
        this.errorMessage =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        this.$log.debug(this.errorMessage);
      }
    );
  },
  components: {
    cardHeader,
    censusToolbar,
    censusTable,
    censusForm,
  },
  mounted() {
    EsepService.getUserInfo(this.$store.state.auth.username).then(
      (response) => {
        this.userInfo = response.data;
        this.$store.state.userInfo = this.userInfo;
        if (!hasRole(this.userInfo,roles.members.census.management)){
          location.replace(routes.nothing);
        }
        this.$log.debug("this.userInfo:");
        this.$log.debug(this.userInfo);
        EsepService.getAccessibleUnits(this.$store.state.auth.username).then(
          (response) => {
            this.usersAdminableUnits = response.data.ADMIN_UNIT;
            this.$store.state.usersAdminableUnits = this.usersAdminableUnits;
            this.usersModableUnits = response.data.MOD_UNIT;
            this.$store.state.usersModableUnits = this.usersModableUnits;
            this.usersAccessibleUnits = response.data.VIEW_UNIT;
            this.$store.state.usersAccessibleUnits = this.usersAccessibleUnits;

            this.$log.debug(this.usersAccessibleUnits);
            let unitsIds = [];
            if (this.usersAccessibleUnits.length == 1) {
              unitsIds.push(this.usersAccessibleUnits[0].id);
              this.selectedUnit = this.usersAccessibleUnits[0];
            } else if (this.usersAccessibleUnits.length > 1) {
              unitsIds.push(this.$store.state.userInfo.orgMember.orgUnit.id);
              this.selectedUnit = this.$store.state.userInfo.orgMember.orgUnit;
              // this.usersAccessibleUnits.forEach(unit => {
              //   unitsIds.push(unit.id);
              // });
            }
            this.$log.debug(this.selectedUnit);
            this.$log.debug(this.currentCensusYear);
            this.getCensusByCriteria(
              unitsIds,
              this.currentCensusYear,
              this.statuses
            );
          },
          (error) => {
            this.errorMessage =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
      },
      (error) => {
        this.errorMessage =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      }
    );
  },
  data() {
    return {
      usersAccessibleUnits: [],
      usersModableUnits: [],
      usersAdminableUnits: [],
      censusList: [],
      selectedUnit: null,
      selectedCensus: null,
      membersList: [],
      statuses: ["APPROVED"],
      fromDate: null,
      toDate: null,
      searchDates: false,
      popAlert: false,
      errorMessage: null
    };
  },
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    getCensusByCriteria: function(unitsIds, year, statuses) {
      EsepService.getCensusByCriteria(unitsIds, year, statuses).then(
        (response) => {
          this.censusList = null;
          this.censusList = response.data;
          this.$log.debug(this.censusList);
        },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
      );
    },
    showCensus: function(value) {
      this.membersList = [];
      this.selectedCensus = value;
      this.selectedCensus.censusMembers.forEach((censusMember) => {
        let member = censusMember.member;
        member.censusIdReplacement = censusMember.idReplacement;
        this.membersList.push(member);
      });
      this.$log.debug(this.selectedCensus);
      this.$log.debug(this.membersList);
    },
    changeCensusYear: function(value) {
      this.selectedCensus = null;
      if(this.censusYear != value) {
         this.censusYear = value;
        this.$log.debug(this.censusYear);
        this.$log.debug('selectedUnit');
        this.$log.debug(this.selectedUnit);
        let unitIds=[];
        if(this.selectedUnit != null) {
          unitIds.push(this.selectedUnit.id);
          this.getCensusByCriteria(unitIds,this.censusYear,this.statuses);
        }
      }
    },
    changeDisplayUnit: function(value) {
      this.selectedCensus = null;
      this.censusList= [];
      this.displayUnit = value;
      if(value != null && this.censusYear != null) {
        EsepService.getOrgUnitById(value.id).then(
          response => {
            this.selectedUnit = response.data;
          },
            (error) => {
              let errorMessage = handleApiError(error);
              this.$emit('error:api', errorMessage);
            }
        )
        this.$log.debug(this.censusYear)
        if(!this.searchDates) {
          this.getCensusByCriteria([value.id], this.censusYear,this.statuses , null , null);
        } else {
          EsepService.getCensusByCriteria([value.id], null, this.statuses , this.fromDate , this.toDate).then(
            response => {
              this.censusList = null;
              this.censusList = response.data;
            },
            (error) => {
              let errorMessage = handleApiError(error);
              this.$emit('error:api', errorMessage);
            }
          );
        }   
      }
      this.selectedUnit = null;
      this.$log.debug(value)
    },
    searchByDates: function(dates) {
      this.selectedCensus = null;
      this.$log.debug(dates);
      let fromDate = dates[0];
      let toDate = dates[1];
      this.fromDate = fromDate;
      this.toDate = toDate;
      let unitsIds = [];
      if(this.displayUnit == null) {
        unitsIds.push(this.selectedUnit.id);
      } else {
        unitsIds.push(this.displayUnit.id);
      }
      this.$log.debug(unitsIds)
      EsepService.getCensusByCriteria(unitsIds, null, this.statuses , fromDate , toDate ).then(
        response => {
          this.$log.debug(response.data)
          this.censusList = [];
          this.censusList = response.data;
          this.searchDates = true;
        },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
      );
    }
  },
};
</script>
